// Recent cafe sales data organized by state
// Data extracted from Cafe Sales.xlsx - ACTUAL DATA

export const cafeSalesData = {
    NSW: [
        { id: 1, salePrice: 1500000, daysOnMarket: 304, interestedBuyers: 107 },
        { id: 2, salePrice: 429435, daysOnMarket: 174, interestedBuyers: 24 },
        { id: 3, salePrice: 410000, daysOnMarket: 125, interestedBuyers: 7 },
        { id: 4, salePrice: 355000, daysOnMarket: 144, interestedBuyers: 35 },
        { id: 5, salePrice: 288000, daysOnMarket: 152, interestedBuyers: 30 },
        { id: 6, salePrice: 188000, daysOnMarket: 221, interestedBuyers: 20 },
        { id: 7, salePrice: 184600, daysOnMarket: 122, interestedBuyers: 14 },
        { id: 8, salePrice: 180000, daysOnMarket: 188, interestedBuyers: 7 },
        { id: 9, salePrice: 165000, daysOnMarket: 324, interestedBuyers: 8 },
        { id: 10, salePrice: 160000, daysOnMarket: 125, interestedBuyers: 13 },
        { id: 11, salePrice: 145000, daysOnMarket: 258, interestedBuyers: 71 },
        { id: 12, salePrice: 140000, daysOnMarket: 375, interestedBuyers: 47 },
        { id: 13, salePrice: 132000, daysOnMarket: 203, interestedBuyers: 17 },
        { id: 14, salePrice: 110000, daysOnMarket: 245, interestedBuyers: 74 },
        { id: 15, salePrice: 104000, daysOnMarket: 131, interestedBuyers: 22 },
        { id: 16, salePrice: 100000, daysOnMarket: 123, interestedBuyers: 11 },
        { id: 17, salePrice: 99000, daysOnMarket: 140, interestedBuyers: 33 },
        { id: 18, salePrice: 80000, daysOnMarket: 316, interestedBuyers: 67 },
        { id: 19, salePrice: 75000, daysOnMarket: 241, interestedBuyers: 17 },
        { id: 20, salePrice: 70000, daysOnMarket: 190, interestedBuyers: 45 },
        { id: 21, salePrice: 55000, daysOnMarket: 315, interestedBuyers: 23 },
        { id: 22, salePrice: 50000, daysOnMarket: 193, interestedBuyers: 69 },
        { id: 23, salePrice: 50000, daysOnMarket: 312, interestedBuyers: 135 },
        { id: 24, salePrice: 42000, daysOnMarket: 446, interestedBuyers: 53 },
        { id: 25, salePrice: 42000, daysOnMarket: 401, interestedBuyers: 34 },
        { id: 26, salePrice: 35000, daysOnMarket: 194, interestedBuyers: 175 },
        { id: 27, salePrice: 34000, daysOnMarket: 224, interestedBuyers: 28 },
        { id: 28, salePrice: 15000, daysOnMarket: 354, interestedBuyers: 49 },
    ],
    QLD: [
        { id: 1, salePrice: 750000, daysOnMarket: 376, interestedBuyers: 29 },
        { id: 2, salePrice: 550000, daysOnMarket: 98, interestedBuyers: 1 },
        { id: 3, salePrice: 390000, daysOnMarket: 294, interestedBuyers: 9 },
        { id: 4, salePrice: 375000, daysOnMarket: 236, interestedBuyers: 11 },
        { id: 5, salePrice: 340000, daysOnMarket: 169, interestedBuyers: 13 },
        { id: 6, salePrice: 295000, daysOnMarket: 80, interestedBuyers: 20 },
        { id: 7, salePrice: 232000, daysOnMarket: 168, interestedBuyers: 59 },
        { id: 8, salePrice: 227250, daysOnMarket: 179, interestedBuyers: 37 },
        { id: 9, salePrice: 190000, daysOnMarket: 217, interestedBuyers: 159 },
        { id: 10, salePrice: 185000, daysOnMarket: 121, interestedBuyers: 38 },
        { id: 11, salePrice: 180000, daysOnMarket: 181, interestedBuyers: 7 },
        { id: 12, salePrice: 155000, daysOnMarket: 277, interestedBuyers: 25 },
        { id: 13, salePrice: 150000, daysOnMarket: 130, interestedBuyers: 25 },
        { id: 14, salePrice: 150000, daysOnMarket: 209, interestedBuyers: 35 },
        { id: 15, salePrice: 145000, daysOnMarket: 163, interestedBuyers: 8 },
        { id: 16, salePrice: 142000, daysOnMarket: 249, interestedBuyers: 48 },
        { id: 17, salePrice: 137000, daysOnMarket: 347, interestedBuyers: 83 },
        { id: 18, salePrice: 125000, daysOnMarket: 156, interestedBuyers: 31 },
        { id: 19, salePrice: 113125, daysOnMarket: 115, interestedBuyers: 18 },
        { id: 20, salePrice: 110000, daysOnMarket: 128, interestedBuyers: 39 },
        { id: 21, salePrice: 108700, daysOnMarket: 162, interestedBuyers: 88 },
        { id: 22, salePrice: 101200, daysOnMarket: 79, interestedBuyers: 32 },
        { id: 23, salePrice: 101000, daysOnMarket: 38, interestedBuyers: 10 },
        { id: 24, salePrice: 100000, daysOnMarket: 119, interestedBuyers: 13 },
        { id: 25, salePrice: 100000, daysOnMarket: 132, interestedBuyers: 24 },
        { id: 26, salePrice: 99500, daysOnMarket: 253, interestedBuyers: 111 },
        { id: 27, salePrice: 92500, daysOnMarket: 224, interestedBuyers: 28 },
        { id: 28, salePrice: 75000, daysOnMarket: 117, interestedBuyers: 43 },
        { id: 29, salePrice: 65000, daysOnMarket: 176, interestedBuyers: 30 },
        { id: 30, salePrice: 30000, daysOnMarket: 231, interestedBuyers: 8 },
        { id: 31, salePrice: 18000, daysOnMarket: 318, interestedBuyers: 119 },
        { id: 32, salePrice: 11000, daysOnMarket: 372, interestedBuyers: 117 },
    ],
    VIC: [
        { id: 1, salePrice: 444000, daysOnMarket: 274, interestedBuyers: 26 },
        { id: 2, salePrice: 399000, daysOnMarket: 280, interestedBuyers: 21 },
        { id: 3, salePrice: 305000, daysOnMarket: 248, interestedBuyers: 5 },
        { id: 4, salePrice: 285000, daysOnMarket: 110, interestedBuyers: 5 },
        { id: 5, salePrice: 280000, daysOnMarket: 237, interestedBuyers: 20 },
        { id: 6, salePrice: 162000, daysOnMarket: 296, interestedBuyers: 75 },
        { id: 7, salePrice: 160162, daysOnMarket: 162, interestedBuyers: 29 },
        { id: 8, salePrice: 160000, daysOnMarket: 324, interestedBuyers: 120 },
        { id: 9, salePrice: 160000, daysOnMarket: 186, interestedBuyers: 65 },
        { id: 10, salePrice: 160000, daysOnMarket: 280, interestedBuyers: 142 },
        { id: 11, salePrice: 160000, daysOnMarket: 68, interestedBuyers: 40 },
        { id: 12, salePrice: 145000, daysOnMarket: 196, interestedBuyers: 27 },
        { id: 13, salePrice: 130000, daysOnMarket: 204, interestedBuyers: 19 },
        { id: 14, salePrice: 130000, daysOnMarket: 360, interestedBuyers: 30 },
        { id: 15, salePrice: 110000, daysOnMarket: 155, interestedBuyers: 34 },
        { id: 16, salePrice: 108500, daysOnMarket: 139, interestedBuyers: 61 },
        { id: 17, salePrice: 105000, daysOnMarket: 363, interestedBuyers: 65 },
        { id: 18, salePrice: 96000, daysOnMarket: 150, interestedBuyers: 81 },
        { id: 19, salePrice: 95000, daysOnMarket: 253, interestedBuyers: 9 },
        { id: 20, salePrice: 90000, daysOnMarket: 391, interestedBuyers: 9 },
        { id: 21, salePrice: 75000, daysOnMarket: 150, interestedBuyers: 4 },
        { id: 22, salePrice: 75000, daysOnMarket: 258, interestedBuyers: 86 },
        { id: 23, salePrice: 62000, daysOnMarket: 361, interestedBuyers: 46 },
        { id: 24, salePrice: 62000, daysOnMarket: 83, interestedBuyers: 21 },
        { id: 25, salePrice: 61000, daysOnMarket: 113, interestedBuyers: 62 },
        { id: 26, salePrice: 60000, daysOnMarket: 189, interestedBuyers: 343 },
        { id: 27, salePrice: 55000, daysOnMarket: 392, interestedBuyers: 71 },
        { id: 28, salePrice: 50000, daysOnMarket: 136, interestedBuyers: 24 },
        { id: 29, salePrice: 50000, daysOnMarket: 123, interestedBuyers: 67 },
        { id: 30, salePrice: 40000, daysOnMarket: 177, interestedBuyers: 60 },
        { id: 31, salePrice: 27000, daysOnMarket: 174, interestedBuyers: 59 },
        { id: 32, salePrice: 19070, daysOnMarket: 231, interestedBuyers: 54 },
        { id: 33, salePrice: 18500, daysOnMarket: 239, interestedBuyers: 124 },
    ],
    WA: [
        { id: 1, salePrice: 350000, daysOnMarket: 236, interestedBuyers: 44 },
        { id: 2, salePrice: 290000, daysOnMarket: 217, interestedBuyers: 57 },
        { id: 3, salePrice: 166000, daysOnMarket: 202, interestedBuyers: 69 },
        { id: 4, salePrice: 143000, daysOnMarket: 92, interestedBuyers: 12 },
        { id: 5, salePrice: 130000, daysOnMarket: 189, interestedBuyers: 14 },
        { id: 6, salePrice: 130000, daysOnMarket: 165, interestedBuyers: 129 },
        { id: 7, salePrice: 115000, daysOnMarket: 170, interestedBuyers: 33 },
        { id: 8, salePrice: 95000, daysOnMarket: 261, interestedBuyers: 82 },
        { id: 9, salePrice: 90000, daysOnMarket: 22, interestedBuyers: 5 },
        { id: 10, salePrice: 65500, daysOnMarket: 245, interestedBuyers: 101 },
        { id: 11, salePrice: 40000, daysOnMarket: 315, interestedBuyers: 50 },
        { id: 12, salePrice: 34000, daysOnMarket: 268, interestedBuyers: 263 },
    ],
};

export const stateInfo = {
    NSW: {
        name: "New South Wales",
        shortName: "NSW",
        description: "Sydney and surrounding regions - Australia's largest café market",
        heroImage: "https://images.pexels.com/photos/1855214/pexels-photo-1855214.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    QLD: {
        name: "Queensland",
        shortName: "QLD", 
        description: "Brisbane, Gold Coast, Sunshine Coast and regional Queensland",
        heroImage: "https://images.pexels.com/photos/2074130/pexels-photo-2074130.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    VIC: {
        name: "Victoria",
        shortName: "VIC",
        description: "Melbourne and Victoria - Australia's coffee capital",
        heroImage: "https://images.pexels.com/photos/1995010/pexels-photo-1995010.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    WA: {
        name: "Western Australia",
        shortName: "WA",
        description: "Perth and Western Australia's growing café scene",
        heroImage: "https://images.pexels.com/photos/2788792/pexels-photo-2788792.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
};

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};
